import * as ng from 'angular';
import { ArchiSmallServices } from '../../../services/archismall.service';
import { appContext } from '../../../app.context';

export const DropzoneBase64 = (ArchiSmallServices: ArchiSmallServices, $rootScope: any, store: ng.a0.storage.IStoreService) => (<angular.IDirective>{

    restrict: 'A',

    link: (scope: any, element: JQuery, attrs: any) => {
        let readFile = (dropzone, file) => {
            if (file) {
                let reader = new FileReader();
                reader.onload = (readerEvt: any) => {
                    try {
                        let binaryString = '';
                        if (!readerEvt) {
                            // readAsBinaryString is missing (IE 11), so we use our method where the read data is

                            // commentato binaryString = reader.content e sostituito con binaryString = reader.result
                            // binaryString = reader.content;
                          var readerResult: any = reader.result;
                            binaryString = readerResult;
                        } else {
                            // commentato binaryString = readerEvt.target.result
                            binaryString = readerEvt.target.result;
                        }

                        if (binaryString === '') {
                            $rootScope.alert('warning', 'There was an error reading the file. Please try again or contact ArchiSMALL Support.');
                            return;
                        }
                        let contentBase64 = btoa(binaryString);
                        if (scope.readFileCallback) {
                            scope.readFileCallback(dropzone, file.name, contentBase64);
                        }
                    } catch (err) {
                        $rootScope.alert('warning', 'File ' + file.name + ' could not be read! ');
                        scope.readFileCallback(false);
                    }
                };
                if (file.size > $rootScope.fatturaPAAttachmentMaxSize) {
                    $rootScope.alert('warning', 'I files allegati superano la dimensione massima accettata (2 MB).');
                    return false;
                } else {
                    if (!appContext.userBrowser.isIE) {
                        reader.readAsBinaryString(file);
                    } else {
                        reader.readAsBinaryStringForChunk(file);
                    }
                }
            }
        };
        let processDragOverOrEnter = (event) => {
            if (event !== null) {
                event.preventDefault();
            }
            // event.dataTransfer.effectAllowed = 'copy';
            element.addClass('dragOver');
            return false;
        };
        let processDragLeave = (event) => {
            if (event !== null) {
                event.preventDefault();
            }
            element.removeClass('dragOver');
            return false;
        };
        let verifyFiles = (files) => {
            if (files.length === 0) {
                $rootScope.alert('warning', 'Nessun File è stato selezionato!');
                return false;
            }

            if (files.length > attrs.dropzoneMaxFileCount) {
                $rootScope.alert('warning', 'Puoi caricare solo ' + attrs.dropzoneMaxFileCount + ' File(s) !');
                return false;
            }

            // check files extension
            let accepted_extensions = JSON.parse(attrs.dropzoneAcceptedExtensions.replace(/'/g, '"'));
            for (let index = 0; index < files.length; index++) {
                var extension = files[index].name.split('.').pop().toLowerCase();
                if ($.inArray(extension, accepted_extensions) === -1) {
                    $rootScope.alert('warning', 'Il File ' + files[index].name + ' non può essere accettato! (I soli formati permessi sono: ' + accepted_extensions + ')');
                    return false;
                }
            }

            // check files size
            for (let index = 0; index < files.length; index++) {
                if (files[index].size === 0) {
                    $rootScope.alert('warning', 'File ' + files[index].name + ' è vuoto! ');
                    return false;
                }
            }

            return true;
        };
        let dropUpload = (event) => {
            if (event !== null) {
                event.preventDefault();
            }

            element.removeClass('dragOver');
            if (!verifyFiles(event.originalEvent.dataTransfer.files)) {
                return false;
            }

            let dropzone = $(event.currentTarget).attr('dropzone-base64');
            let files = event.originalEvent.dataTransfer.files;
            for (let index = 0; index < files.length; index++) {
                let file = files[index];
                readFile(dropzone, file);
            }
        };
        let inputUpload = (event) => {
            if (event !== null) {
                event.preventDefault();
            }

            if (!verifyFiles(event.target.files)) {
                return false;
            }
            let dropzone = $(event.target).parent('div').attr('dropzone-base64');
            let files = event.target.files;
            for (let index = 0; index < files.length; index++) {
                let file = files[index];
                readFile(dropzone, file);
            }

            let $input = $(event.target);

            $input.wrap('<form>').closest('form').get(0).reset();
            $input.unwrap();
        };
        element.bind('dragover', processDragOverOrEnter);
        element.bind('dragenter', processDragOverOrEnter);
        element.bind('dragleave', processDragLeave);
        element.bind('drop', dropUpload);
        element.bind('change', inputUpload);
        element.bind('click', (e) => {
            if (e.originalEvent) {
                $(element).find('input[type=file]').click();
            }
        });
        element.html(element.html() + `<input type='file' multiple style='display:none'/> <progress max='100' value='0' ></progress>`);
        let progress = (x) => {
            $('div[dropzone="' + attrs.dropzone + '"]').find('progress').val(x);
        };

    }
});

DropzoneBase64.$inject = ['ArchiSmallServices', '$rootScope', 'store'];



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/drop-zone-base64/drop-zone-base64.directive.ts